export const removeQueryParam = (param: string): void => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete(param);
  window.history.replaceState(
    {},
    document.title,
    `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`,
  );
};

export const readQueryParam = (param: string): string | undefined =>
  new URLSearchParams(window.location.search).get(param) ?? undefined;

export default {
  readQueryParam,
  removeQueryParam,
};
